// `video.reframe`: live's Reframe tool (#212).
// Live's label map (`REFRAME_VIDEO`); the tool's own form builds the body.
import { VideoReframeQuote, VideoReframeRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.reframe"> = {
  type: "video.reframe",
  label: "Reframe",
  source: "form",
  pair: "video.reframe",
  fields: () => ({}),
  request: VideoReframeRequest,
  quote: VideoReframeQuote,
};
